<app-timezone-selector
  [timeZone]="selectedTimezone()"
  [dateFormat]="selectedDateFormat()"
  [saving]="isSavingTimezone()"
  [saveVersion]="timezoneSaveVersion()"
  (save)="onTimezoneSettingsSave($event)"
></app-timezone-selector>
